module.exports = __webpack_public_path__ + "static/media/coming-soon.19b6e8e3.png";